module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-mv-image-3-sp-7a406f5556e88d9cba851ebc04dafa6e.png";